export const DEPOSIT_CONTAINER_TAG_NAME = 'deposit-container';
